module.exports = __webpack_public_path__ + "img/introducePageTwo_show_eight.18050854.jpg";